// extracted by mini-css-extract-plugin
module.exports = {"main":"LogoNameStack-module--main--23vDW","image":"LogoNameStack-module--image--37KX4","name":"LogoNameStack-module--name--3KH2-"};